import { Loader2 } from 'lucide-react';

interface LoadingStateProps {
  message?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-10 w-10',
};

export function LoadingState({ message, className = '', size = 'md' }: LoadingStateProps) {
  return (
    <div className={`flex flex-col items-center justify-center py-12 text-center ${className}`}>
      <Loader2 className={`${sizeClasses[size]} animate-spin text-muted-foreground mb-3`} />
      {message && <p className="text-sm text-muted-foreground">{message}</p>}
    </div>
  );
}

/** Inline spinner for buttons etc. */
export function Spinner({ className = 'h-4 w-4' }: { className?: string }) {
  return <Loader2 className={`${className} animate-spin`} />;
}
